module.exports = __webpack_public_path__ + "img/certificate3.b4851d3f.jpg";